module.exports = __webpack_public_path__ + "static/media/benu-offer.956507fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/benu-offer.png
// module id = 1497
// module chunks = 0